<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="grid-col flex-auto">
      <legend class="usa-legend usa-legend--large">HHG Rate Filing Administration</legend>
    </div>
    <div class="grid-col flex-auto margin-left-2">
      <ul class="usa-nav__primary usa-accordion">
        <li class="usa-nav__primary-item">
          <button class="usa-accordion__button define-eclipse" aria-expanded="false" aria-controls="more-actions"
                  data-tooltip="Click for more options">
            <span>&hellip;</span>
          </button>
          <ul id="more-actions" class="usa-nav__submenu" hidden>
            <li class="usa-nav__submenu-item">
              <a routerLink="/hhgratefiletspext" routerLinkActive="active">Extend TSP Closing Date</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a (click)="openExtendRates()">Extend Current Rates</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
  <form [formGroup]="hhgRatesBidcyclesForm">
    <fieldset class="usa-fieldset">
      <div class="grid-row" *ngIf="isError">
        <div class="usa-alert usa-alert--error usa-alert--slim">
          <div class="usa-alert__body">
            <p class="usa-alert__text">
              {{errorMessage}}
            </p>
          </div>
        </div>
      </div>
      <div class="grid-row grid-gap">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <legend class="usa-legend usa-legend--medium">Bid Cycle Information</legend>
          <div class="grid-row">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="bidCycle" class="usa-label">Bid Cycle Name<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <input type="text" id="bidCycle" class="usa-input maxw-full" formControlName="bidCycle" (change)="onCycleNameChange($event)">
              <small class="define-text-secondary" *ngIf="this.hhgRatesBidcyclesForm.get('bidCycle').touched && this.hhgRatesBidcyclesForm.get('bidCycle').hasError('required')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Bidcycle name is required.
              </small>
              <small class="define-text-secondary" *ngIf="this.hhgRatesBidcyclesForm.get('bidCycle').touched && this.bidcycleError">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>Bidcycle name is already available. Please use another name.
              </small>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="bid_open_date" class="usa-label">Rate Filing Open Date<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <input type="text" id="bid_open_date" class="usa-input maxw-full" placeholder="mm/dd/yyyy" formControlName="bidOpenDate" (bsValueChange)="bidOpenDateChange($event)" [minDate]="bidOpenMinDate" [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"
                     [value]="this.hhgRatesBidcyclesForm.get('bidOpenDate').value | date: 'MMM d, y'" bsDatepicker placement="right">
              <small class="define-text-secondary" *ngIf="this.hhgRatesBidcyclesForm.get('bidOpenDate').touched && this.hhgRatesBidcyclesForm.get('bidOpenDate').hasError('required')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>Rate Filing Open Date is required.
              </small>
              <small class="define-text-secondary" *ngIf="this.hhgRatesBidcyclesForm.get('bidOpenDate').touched && (this.bidOpenDateErrorType == 'A')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>Rate Filing Open Date should be after Today.
              </small>
              <small class="define-text-secondary" *ngIf="this.hhgRatesBidcyclesForm.get('bidCloseDate').touched && (this.bidOpenDateErrorType == 'B')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>Rate Filing Open Date should be on or before Rate Filing Close Date.
              </small>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label class="usa-label" for="delivery-date"> Rate Filing Close Date and Time<abbr title="required"
                                                                                                 class="usa-hint usa-hint--required">*</abbr></label>
              <div class="grid-row grid-gap">
                <div class="grid-col-8 mobile-lg:grid-col-8 tablet:grid-col-8 desktop:grid-col-8">
                  <div class="usa-date-picker usa-date-picker--initialized" data-min-date="0000-01-01">
                    <input class="usa-input usa-date-picker__internal-input" aria-labelledby="bid-CloseDate-label"
                           aria-describedby="bid-CloseDate-hint" aria-hidden="true" tabindex="-1" style="display: none;" >
                    <div class="usa-date-picker__wrapper">
                      <input class="usa-input usa-date-picker__external-input" formControlName="bidCloseDate"
                             id="bi-dCloseDate-date" name="bid-CloseDate-date" aria-labelledby="bid-CloseDate-label"
                             aria-describedby="bid-CloseDate-hint" type="text" (change)="bidCloseDateChange($event)">
                      <button type="button" class="usa-date-picker__button tmss-datepicker-custom" aria-haspopup="true"
                              aria-label="Toggle calendar" [disabled]="hhgBidCycleClosedDate"></button>
                      <div class="usa-date-picker__calendar" role="application" hidden=""></div>
                      <div class="usa-sr-only usa-date-picker__status" role="status" aria-live="polite"></div>
                    </div>
                  </div>
                  <!-- {{this.hhgRatesBidcyclesForm.get('dateSelection')?.hasError('validDateTime')}}
                   <small class="define-text-secondary"  *ngIf="(this.hhgRatesBidcyclesForm?.get('timeSelection')?.hasError('touched') || this.hhgRatesBidcyclesForm?.get('dateSelection')?.hasError('touched')) && (this.hhgRatesBidcyclesForm?.get('timeSelection')?.hasError('required') || this.hhgRatesBidcyclesForm?.get('dateSelection')?.hasError('required') || this.hhgRatesBidcyclesForm.get('dateSelection')?.hasError('validDateTime'))">
                       <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                           <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                           </svg>Rate Filing Close Date is required.
                   </small> -->
                </div>

                <div class="grid-col-4 mobile-lg:grid-col-4 tablet:grid-col-4 desktop:grid-col-4">
                  <select class="usa-select usa-combo-box__select tmss-custom-select" name="options" id="options" formControlName="timeSelection">
                    <option *ngFor="let hr of this.listHrs" [value]="hr.key">{{hr.value}}</option>
                  </select>
                </div>
              </div>


              <!-- <ngx-datetime-picker disableInput="true" id="delivery-date" formControlName="bidCloseDate" (selectedDateTimeChange)="bidCloseDateChange($event)" [disableButton]=disableUpdateButton>
              </ngx-datetime-picker> -->
              <small class="define-text-secondary" *ngIf="this.hhgRatesBidcyclesForm.get('bidCloseDate').touched && this.hhgRatesBidcyclesForm.get('bidCloseDate').hasError('required')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>Rate Filing Close Date is required.
              </small>
              <small class="define-text-secondary" *ngIf="this.bidCloseDateError && (this.bidCloseDateErrorType == 'A')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>Bid Close Close should be after Today.
              </small>
              <small class="define-text-secondary" *ngIf="this.bidCloseDateError && (this.bidCloseDateErrorType == 'B')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>Rate Filing Close Date should be after Rate Filing Open Date.
              </small>
            </div>
            <!-- <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label" for="delivery-date"> Rate Filing Close Date<abbr title="required"
                                                                                class="usa-hint usa-hint--required">*</abbr></label>
                <ngx-datetime-picker disableInput="true" id="delivery-date" formControlName="bidCloseDate" (selectedDateTimeChange)="bidCloseDateChange($event)" [disableButton]=disableUpdateButton>
                </ngx-datetime-picker>
                <small class="define-text-secondary" *ngIf="this.hhgRatesBidcyclesForm.get('bidCloseDate').touched && this.hhgRatesBidcyclesForm.get('bidCloseDate').hasError('required')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>Rate Filing Close Date is required.
                </small>
                <small class="define-text-secondary" *ngIf="this.bidCloseDateError && (this.bidCloseDateErrorType == 'A')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>Bid Close Close should be after Today.
                </small>
                <small class="define-text-secondary" *ngIf="this.bidCloseDateError && (this.bidCloseDateErrorType == 'B')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>Rate Filing Close Date should be after Rate Filing Open Date.
                </small>
            </div> -->
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="eff_open_date" class="usa-label">Rate Effective Date<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <input type="text" id="eff_open_date" class="usa-input maxw-full" placeholder="mm/dd/yyyy" formControlName="effOpenDate" (bsValueChange)="effOpenDateChange($event)" [minDate]="effOpenMinDate" [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"
                     [value]="this.hhgRatesBidcyclesForm.get('effOpenDate').value | date: 'MMM d, y'" bsDatepicker placement="right">
              <small class="define-text-secondary" *ngIf="this.hhgRatesBidcyclesForm.get('effOpenDate').touched && this.hhgRatesBidcyclesForm.get('effOpenDate').hasError('required')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>Rate Effective Date is required.
              </small>
              <small class="define-text-secondary" *ngIf="this.hhgRatesBidcyclesForm.get('effOpenDate').touched && (this.effOpenDateErrorType == 'A')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>Rate Effective Date should be after Today.
              </small>
              <small class="define-text-secondary" *ngIf="this.effOpenDateError && (this.effOpenDateErrorType == 'B')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>Rate Effective Date should be after Rate Filing Close Date.
              </small>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="eff_close_date" class="usa-label">Rate Expiry Date<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <input type="text" id="eff_close_date" class="usa-input maxw-full" placeholder="mm/dd/yyyy" formControlName="effCloseDate" (bsValueChange)="effCloseDateChange($event)" [minDate]="effCloseMinDate" [value]="this.hhgRatesBidcyclesForm.get('effCloseDate').value | date: 'MMM d, y'"
                     [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}" bsDatepicker placement="right">
              <small class="define-text-secondary" *ngIf="this.hhgRatesBidcyclesForm.get('effCloseDate').touched && this.hhgRatesBidcyclesForm.get('effCloseDate').hasError('required')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>Rate Expiry Date is required.
              </small>
              <small class="define-text-secondary" *ngIf="this.hhgRatesBidcyclesForm.get('effCloseDate').touched && (this.effCloseDateErrorType == 'A')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>Rate Expiry Date is required.
              </small>
              <small class="define-text-secondary" *ngIf="this.hhgRatesBidcyclesForm.get('effCloseDate').touched && (this.effCloseDateErrorType == 'B')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>Rate Expiry Date should be after Rate Effective Date.
              </small>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="pcMiler" class="usa-label">PC Miler Version<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <select id="pcMiler" class="usa-select maxw-full" formControlName="pcMiler" (change)="onPcMilerChange($event.target.value)">
                <option value='' selected disabled>Choose...</option>
                <option *ngFor="let pcMiler of pcMilerList" [value]="pcMiler.rateKey">{{pcMiler.rateKey}}</option>
              </select>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label class="usa-label" for="supplemental">Supplemental Rate Filing<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <select id="supplemental" class="maxw-full usa-select" formControlName="hhgSupplementalFiling">
                <option value='' selected disabled>Choose...</option>
                <option value='1'>Yes</option>
                <option value='0'>No</option>
              </select>
            </div>
          </div>


        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
          <legend class="usa-legend usa-legend--medium">SRO</legend>
          <div class="grid-row grid-gap-2">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-5">
              <label for="all_sros" class="usa-label">List of all SROs</label>
              <select id="all_sros" class="define-height-usa-select usa-select maxw-full" formControlName="allSros" multiple size="5">
                <option value='' selected disabled>Choose...</option>
                <option *ngFor="let sro of sroListByRateType" [value]="sro.sroMasterId">{{sro.sroId}}</option>
              </select>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2 text-center define-margin-x-y-auto">
              <button type="button" class="usa-button width-full" (click)="moveItems()">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#arrow_forward"></use>
                </svg>
              </button>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-5">
              <label for="assigned_sros" class="usa-label">SROs assigned<abbr title="required"
                                                                              class="usa-hint usa-hint--required">*</abbr></label>
              <select id="assigned_sros" size="5" formControlName="assignedSros" class="define-height-usa-select usa-select  maxw-full" multiple>
                <option *ngFor="let sro of assignedSroList; let i = index" (dblclick)="handleSroMultiDropdown(i)"[value]="sro.sroMasterId">{{sro.sroId}}</option>
              </select>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="addlText" class="usa-label">Additional Text<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <textarea type="text" id="addlText" class="usa-textarea maxw-full" formControlName="addlText" maxlength="250" (change)="onAddlText($event)"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="margin-top-2">
        <ul class="usa-button-group">
          <li class="usa-button-group__item">
            <button type="button" class="usa-button" [disabled]="disableCreateBtn || disableUpdateButton" (click)="saveRateFileRec()">{{this.updateBtnText }}</button>
          </li>
          <li class="usa-button-group__item">
            <button type="button" class="usa-button usa-button--outline" *ngIf="showPublish" (click)="publishBidcycle()">Publish</button>
          </li>
          <li class="usa-button-group__item">
            <button type="button" class="usa-button usa-button--outline" (click)="clearPage()">Cancel</button>
          </li>
          <!--Release to preprod, works only in production-->
          <li class="usa-button-group__item">
            <button type="button" class="usa-button usa-button--outline" *ngIf="showPreprod" (click)=" releaseToPreprod()">Release to Preprod</button>
          </li>
          <li class="usa-button-group__item">
            <button type="button" class="usa-button usa-button--outline" *ngIf="showProduction" (click)="releaseToProduction()">Release to Production</button>
          </li>
        </ul>
      </div>
    </fieldset>
  </form>
  <div class="margin-top-5">
    <ag-grid-angular class="ag-theme-alpine" [rowData]="rateBidcyclesList" [domLayout]="domLayout" [pagination]="true" [paginationPageSize]="itemsPerPage" [columnDefs]="rateBidcyclesColumnDefs">
    </ag-grid-angular>
  </div>
</div>
